import { useAuth } from '../auth/useAuth'

/** For team members: a reminder that totals and lists cover their own leads only (admins see everything). */
export default function ScopeNote() {
  const { user } = useAuth()
  if (!user || user.isAdmin) return null
  return <p className="scope-note">Showing your leads: the ones you created or own.</p>
}
